<template>
	<div id="sign_body">
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>
		<van-form @submit="onSubmit" style="padding-bottom: 80px;">
			<van-field v-model="client_text" name="关联客户" label="关联客户" placeholder="选择关联客户" readonly
				@click="popup.client = true" :rules="[
				{
					required: true,
					trigger: 'onBlur',
					message: '请选择关联客户',
				},
			]" />
			<van-field label="拜访地址" readonly v-model="form.client_address" />
			<van-field label="位置" value="点击获取位置" readonly @click="getLocation" v-model="form.sign_address">
				<template #button>
					<span :class="{ 'high-accuracy': highAccuracy, 'low-accuracy': !highAccuracy }">
						{{ highAccuracy ? '高精度' : '低精度' }}
					</span>
				</template>
			</van-field>
			<!-- 使用 van-field 包裹地图容器 -->
			<van-field name="map" label="地图" readonly v-show="mapVisible">
				<template #input>
					<div id="mapContainer" style="width: 100%; height: 200px;"></div>
				</template>
			</van-field>
			<van-field name="uploader" label="附件上传">
				<template #input>
					<van-uploader v-model="form.uploader" :max-count="3" accept="image/*" capture="camera"
						:after-read="onAfterRead" />
					<!-- 修改为只允许拍照不允许本地上传 -->
				</template>
			</van-field>
			<van-field v-model="form.sign_remark" rows="3" autosize label="备注" type="textarea" placeholder="请输入备注" />
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-tabbar v-model="activeName" fixed>
			<van-tabbar-item name="sign" icon="location-o" to="/sign">签到</van-tabbar-item>
			<van-tabbar-item name="list" icon="label-o" to="/sign/list">签到记录</van-tabbar-item>
			<van-tabbar-item name="survey" icon="browsing-history-o" to="/survey">勘察</van-tabbar-item>
			<van-tabbar-item name="surveyList" icon="certificate" to="/survey/list">勘察记录</van-tabbar-item>
		</van-tabbar>

		<van-popup v-model="popup.client" position="right" :style="{ width: '60%', height: '100%' }">
			<popup-select v-model="clientList.list" @onload="onloadClient" @check="checkClient"
				:loading="clientList.loading" :finished="clientList.finished" value-key="client_name"></popup-select>
		</van-popup>

		<van-overlay :show="!signTime">
			<div class="wrapper">
				<van-loading size="24px">文件上传中,请稍后...</van-loading>
			</div>
		</van-overlay>

		<div>{{ mes }}</div>
	</div>
</template>
<script type="text/javascript" src="https://webapi.amap.com/maps?v=2.0">
</script>

<script>
import popupselect from "@/components/select/index";
import navbar from "@/components/navBar/index";
// import { getDetailed } from "@/api/map";
import { post } from "@/api/dispatch";
import { Toast, Dialog } from "vant";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { compressImage } from "@/utils/imageUtils"; 
import AMapLoader from '@amap/amap-jsapi-loader';

export default {
	name: "sign",
	components: {
		navbar,
		"popup-select": popupselect,
	},
	data() {
		return {
			title: "签到",
			localIndex: 0,
			key: "Q47BZ-4MJLM-3GQ6K-6XD3X-MKNOJ-CXFJ2",
			form: {
				sign_remark: "",
				longitude: 0, //经度
				latitude: 0, //纬度
				sign_address: "点击获取位置",
				client_id: "",
				client_address: "",
				uploader: [],
			},
			activeName: "sign",
			clientList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 20,
			},
			popup: {
				client: false,
			},
			client_text: "",
			signTime: true,
			geolocation: "",
			mes: "",
			locationTimeOut: true, // 判断是否长时间为获取地址信息
			locations: [], // 存储多个定位结果
			highAccuracy: false, // 默认假设是低精度
			currentAccuracy: 0, // 当前精度
            map: null, // 地图实例
			mapVisible: false, // 添加地图可见性控制变量
		};
	},
	mounted() {
		// 开始定位
		// this.getLocation();
	},
	methods: {
		async onAfterRead(file) {
			//图片压缩
			if (file.file.type.startsWith('image/')) {
				const compressedFile = await compressImage(file.file);
				// 替换原始文件为压缩后的文件
				file.file = compressedFile;
				// console.log('File after compression:', file.file); // 添加调试信息
			} 
		},
		onSubmit() {
			let that = this;

			console.log(this.form);
			if (!this.form.sign_remark) {
				return this.$toast.fail("请输入备注");
			}
			if (
				this.form.sign_address === "点击获取位置" ||
				this.form.sign_address === "获取位置失败,请点击重试!"
			) {
				return this.$toast.fail("请输入先获取位置");
			}
			if (this.form.uploader.length === 0) {
				return this.$toast.fail("请上传附件");
			}

			this.form.requestType = "visit_save";
			let formData = new FormData();

			for (let i = 0; i < this.form.uploader.length; i++) {
				formData.append("file", this.form.uploader[i].file);
			}
			formData.append("sign_remark", this.form.sign_remark);
			formData.append("longitude", this.form.longitude);
			formData.append("latitude", this.form.latitude);
			formData.append("sign_address", this.form.sign_address);
			formData.append("client_id", this.form.client_id);
			formData.append("requestType", "visit_save");
			formData.append("token", getToken());

			const config = {
				timeout: 60 * 1000,
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			this.signTime = false;
			axios
				.post(this.GLOBAL.httpURL, formData, config)
				.then(function (res) {
					that.signTime = true;
					if (res.status === 200) {
						Toast.fail("签到成功!");
						that.form.sign_remark = "";
						that.form.longitude = 0;
						that.form.latitude = 0;
						that.client_text = "";
						that.form.client_id = "";
						that.form.client_address = "";
						that.form.sign_address = "点击获取位置";
						that.form.uploader = [];
					} else {
						Toast.fail("网路连接错误,请稍后重试!");
					}
				})
				.catch((err) => {
					console.log(err);
					that.signTime = true;
					let text = "当前网络环境差,请重新提交!";
					this.$toast.fail(text);
				});
		},
		getLocation() {
			// console.log("开始定位",window);
			this.locations = []; // 清空之前的定位结果
			this.locationTimeOut = true;
			this.$toast.loading("正在获取位置...");

			// 同时请求多个定位服务
			// this.getQQMapLocation();
			// this.getBaiduMapLocation();
			this.getAMapLocation();
		},
		
		getQQMapLocation() {
			var options = { timeout: 8000, enableHighAccuracy: true };
			let geolocation = new qq.maps.Geolocation(this.key, "myapp"); // eslint-disable-line
			geolocation.getLocation((position) => {
				this.handleLocationResult(position, "腾讯地图");
					// console.log("腾讯地图精度",position.accuracy)
			}, this.showErr, options);
		},
		getBaiduMapLocation() {
			let BMap = window.BMap;
			var geolocation = new BMap.Geolocation();
			geolocation.getCurrentPosition((position) => {
					// console.log("百度地图返回:",geolocation);
				if (geolocation.getStatus() === window.BMAP_STATUS_SUCCESS) {
					this.handleLocationResult({
						lat: position.latitude,
						lng: position.longitude,
						accuracy: position.accuracy || 100 // 百度地图可能没有 accuracy 字段
					}, "百度地图");
					// console.log("百度地图精度",position.accuracy)
				} else {
					console.error("百度地图定位失败: " + geolocation.getStatus());
				}
			}, { enableHighAccuracy: true });
		},
		getAMapLocation() {
				AMapLoader.load({
				key: "b57072c12a038fbc71ba11248a5e6a0e",
				version: "2.0",
				plugins: [
					"AMap.Geocoder",
					"AMap.Marker",
					"AMap.ToolBar",
					"AMap.Scale",
					"AMap.ElasticMarker",
					"AMap.Geolocation",
					"AMap.AutoComplete"
				]
				}).then((AMap) => {
					var geolocation = new AMap.Geolocation({
					// 是否使用高精度定位，默认：true
					enableHighAccuracy: true,
					//是否使用安卓定位sdk用来进行定位，需要安卓端sdk配合
					useNative: true,
					// 设置定位超时时间，默认：无穷大
					timeout: 10000,
					needAddress: true,
				});
			geolocation.getCurrentPosition((status, result) => {
				// console.log("高德地图返回:",result);
				if (status === 'complete') {
					this.handleLocationResult({
						lat: result.position.lat,
						lng: result.position.lng,
						accuracy: result.accuracy
					}, "高德地图");
					// console.log("高德地图精度",result.accuracy)
				} else {
					console.error("高德地图定位失败: " + status);
				}
			});
				}).catch((e) => {
				console.log(e);
				});
		},
		handleLocationResult(position, source) {
			this.locations.push({
				source: source,
				lat: position.lat,
				lng: position.lng,
				accuracy: position.accuracy
			});
			console.log(this.locations.length);
			// 检查是否所有定位服务都已返回结果
			// if (this.locations.length >= 3) {
				this.fuseLocations();
			// }
		},
		fuseLocations() {
            this.locationTimeOut = false;
            this.$toast.clear();

            // 过滤掉精度较差的结果
            const filteredLocations = this.locations;
			// .filter(loc => loc.accuracy <= 10000); // 只保留精度在100米以内的结果

            if (filteredLocations.length === 0) {
                this.$toast.fail("定位结果精度较低，请重新获取位置。");
                return;
            }

            // 对过滤后的结果进行简单平均
            let totalLat = 0;
            let totalLng = 0;

            filteredLocations.forEach(location => {
                totalLat += location.lat;
                totalLng += location.lng;
            });

            const fusedLat = totalLat / filteredLocations.length;
            const fusedLng = totalLng / filteredLocations.length;
			

            // 计算融合后的精度
            const fusedAccuracy = Math.min(...filteredLocations.map(loc => loc.accuracy));

            this.latitude = fusedLat;
            this.longitude = fusedLng;
            this.currentAccuracy = fusedAccuracy;
            this.highAccuracy = fusedAccuracy <= 300; // 假设300米以内为高精度

            if (!this.highAccuracy) {
                Dialog.confirm({
                    title: '定位精度较低',
                    message: `当前定位精度为 ${fusedAccuracy} 米，建议重新获取位置。`,
                    confirmButtonText: '重新获取',
                    cancelButtonText: '采用当前位置'
                }).then(() => {
                    this.getLocation();
                }).catch(() => {
                    // 用户取消操作
                });
            } else {
                this.$toast.success(`当前定位精度为 ${fusedAccuracy} 米`);
            }
			// 初始化地图并标记位置
			this.initMap(fusedLng, fusedLat);
			// 根据经纬度去查询地址
			// getDetailed({
			// 	requestType: "visit_sign_positioning",
			// 	longitude: this.longitude,
			// 	latitude: this.latitude,
			// })
			// 	.then((response) => {
			// 		this.$toast.success("获取成功");
			// 		if (response.obj.result.formatted_addresses.standard_address) {
			// 			this.form.sign_address = response.obj.result.formatted_addresses.standard_address;
			// 		} else {
			// 			this.form.sign_address = response.obj.result.address;
			// 		}
			// 	})
			// 	.catch(() => {
			// 		this.$toast.fail("服务器发生错误");
			// 	});
			this.geocoder = new AMap.Geocoder({
				city: "全国",
				radius: 50,
				extensions: "all",
			});
				this.geocoder.getAddress([this.longitude, this.latitude], (status, result) => {
				if (status === "complete" && result.info === "OK") {
					if (result && result.regeocode) {
						this.$toast.success("获取成功");
					this.form.sign_address = result.regeocode.formattedAddress;
					} else {
					Toast.fail('逆地理编码失败，请稍后重试');
					}
				}
			});

			this.form.latitude = fusedLat;
			this.form.longitude = fusedLng;
		},
		getLocationTimeOut() {
			setTimeout(() => {
				if (this.locationTimeOut) {
					Dialog.alert({
						title: "定位失败",
						message: "如果您网路无问题,请打开app设置,开启定位权限",
					});
				}
			}, 20 * 1000);
		},
		showErr() {
			this.$toast.fail("获取失败");
			if (this.localIndex === 0) {
				this.localIndex += 1;
				this.getLocation();
			} else {
				this.local = "获取位置失败,请点击重试!";
			}
		},
		onloadClient(search) {
			// 防止重复请求
			if (this.clientList.loading) {
				return;
			}
			// 设置加载状态
			this.clientList.loading = true;
			if (search != undefined) {
				this.clientList.page = 1;
			}
			post({
				requestType: "client_list",
				page: this.clientList.page,
				limit: this.clientList.limit,
				client_name: search,
			})
				.then((res) => {
					if (res.obj.rows.length === 0) {
						this.clientList.finished = true;
					}
					if (this.clientList.page != 1) {
						this.clientList.list = this.clientList.list.concat(res.obj.rows);
					} else {
						this.clientList.list = res.obj.rows;
					}

					this.clientList.page += 1;
					this.clientList.loading = false;
				})
				.catch((err) => {
					console.log(err);
					this.clientList.loading = false;
					this.clientList.finished = true;
					return this.$toast.fail("数据异常");
				});
		},
		checkClient(value) {
			console.log(value);
			this.form.client_address = value.address;
			this.popup.client = false;
			this.client_text = value.client_name;
			this.form.client_id = value.client_id;
		},
		initMap(longitude, latitude) {
            // 创建地图实例
            this.map = new AMap.Map('mapContainer', {
                zoom: 16, // 缩放级别
                center: [longitude, latitude] // 地图中心点
            });

            // 创建标记
            const marker = new AMap.Marker({
                position: new AMap.LngLat(longitude, latitude), // 标记位置
                title: '当前位置' // 标记标题
            });

            // 将标记添加到地图
            this.map.add(marker);
			// 地图初始化成功后，设置 mapVisible 为 true
            this.mapVisible = true;
        }
	},
};
</script>

<style lang="scss">
#sign_body {
	.van-form {
		height: auto;
		/* 确保表单高度自动调整 */
	}

	#sign_body {
		overflow-y: auto;
		/* 允许垂直滚动 */
	}
	.wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.van-loading__text {
		color: #ffffff;
	}
	
    .high-accuracy {
        color: green;
    }

    .low-accuracy {
        color: red;
    }
}
</style>
